import axios, { AxiosResponse } from 'axios';
import { WishListRequestModel, WishList, WishListProduct, WishListItem } from '@/models/WishList';

export default class WishListService {

    private profileId: string = (window as any).CbxApiContextKey;
    private endpoint: string;

    constructor(args: any = {}) {
        if (args.profileId)
            this.profileId = args.profileId;
        this.endpoint = `/contextapi/${this.profileId}/v1/wishlist`;
    }

    public async getWishLists(): Promise<WishListRequestModel> {
        try {
            const res: AxiosResponse<any> = await axios.get(`${this.endpoint}`);
            return res.data;
        } catch (e) {
            console.log(e);
        }
    }

    public async removeWishList(label: string): Promise<string> {
        try {
            await axios.delete(`${this.endpoint}/${label}`);
            return label;
        } catch (e) {
            console.log(e);
        }
    }

    public async addWishListItem(item: WishListItem): Promise<WishListProduct> {
        try {
            const res: AxiosResponse<any> = await axios.post(`${this.endpoint}`, item);
            return res.data;
        } catch (e) {
            console.log(e);
        }
    }

    public async removeWishListItem(label: string, productid: string): Promise<WishList> {
        try {
            const res: AxiosResponse<any> = await axios.delete(`${this.endpoint}/${label}/${productid}`);
            return res.data;
        } catch (e) {
            console.log(e);
        }
    }

    public async updateWishList(payload: WishList): Promise<WishList> {
        try {
            const res: AxiosResponse<WishList> = await axios.post(`${this.endpoint}/updatelist`, payload);
            return res.data;
        } catch (e) {
            console.log(e);
        }
    }

}
